// extracted by mini-css-extract-plugin
export default {"outer":"toggle_outer__TpPlg","inline":"toggle_inline__gc0fE","fullWidth":"toggle_fullWidth__tLir0"};